import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import Chip from '@mui/material/Chip';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from "react-i18next";
import { exchangeToken } from '../../actions/users'
import jwt_decode from "jwt-decode";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useCookieContext } from '../../components/cookiesModal/cookie-context';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import useLocalStorage from '../../hook/useLocalStorage';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
            '#fff',
          )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#aab4be',
          ...theme.applyStyles('dark', {
            backgroundColor: '#8796A5',
          }),
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#001e3c',
      width: 32,
      height: 32,
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
      },
      ...theme.applyStyles('dark', {
        backgroundColor: '#003892',
      }),
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: '#aab4be',
      borderRadius: 20 / 2,
      ...theme.applyStyles('dark', {
        backgroundColor: '#8796A5',
      }),
    },
  }));

export default function UserProfile(props) {
    const { setIsCookieIcon } = useCookieContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    let token = localStorage.getItem("saxToken")

    const infoUser = token ? jwt_decode(token) : null;


    const [openAlert, setOpenAlert] = useState(false);
    const [notificaciones, setNotificaciones] = useLocalStorage('NotificacionesSAX', true);
    const [modoOscuro, setModoOscuro] = useLocalStorage('ModoOscuroSAX', false);

    useEffect(() => {
    const savedMode = localStorage.getItem('ModoOscuroSAX') === 'true';
    setModoOscuro(savedMode);

    if (savedMode) {
        document.body.classList.add('dark-mode');
    } else {
        document.body.classList.remove('dark-mode');
    }
    }, []);

    const handleCloseAlert = (event, reason) => {

        setOpenAlert(false);
    };


    const copyToken = async() => {
        let token = localStorage.getItem("saxToken")
        navigator.clipboard.writeText(token)
        setAnchorEl(null);
        setOpenAlert(true)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [t, i18next] = useTranslation("global")

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

                <Chip avatar={<Avatar>{props && props.infoUser ?  props.infoUser.name[0].toUpperCase(): 'U'}</Avatar>} label={props && props.infoUser ?  props.infoUser.name: 'Usuario'} onClick={handleClick} />
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        }
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}



            >

                <SimpleTreeView>
                    <TreeItem itemId="download" label={
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: ".5rem", fontSize: "14px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" style={{margin: "0.5rem"}}>
                            <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/>
                        </svg>
                            {t("board.downLoad")}
                        </div>
                    }>
                        <TreeItem itemId="power-factory" onClick={()=> {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: 'button_click',
                              button_id:'download-pf',
                            });
                            {
                                infoUser && infoUser.userType === 6 ?
                                window.open(`${process.env.REACT_APP_BACKEND_URL}/api/download-demo/PowerFactoryGenerator`)
                                :
                                window.open(`${process.env.REACT_APP_BACKEND_URL}/api/download-demo/PowerFactory`)
                            }
                            setAnchorEl(null)
                        }}
                        label={
                                    <p style={{marginTop: "0.4rem", marginBottom: "0.4rem", fontSize: "14px"}}>Power Factory</p>
                                } />
                        <TreeItem itemId="psse" onClick={()=>{
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: 'button_click',
                              button_id:'download-psse',
                            });
                            window.open( `${process.env.REACT_APP_BACKEND_URL}/api/download-demo/PSSE`)
                            setAnchorEl(null)
                        }}
                        label={
                                    <p style={{marginTop: "0.4rem", marginBottom: "0.4rem", fontSize: "14px"}}>PSSE v35 - v36</p>
                                } />
                        {/* {((infoUser && infoUser.admin) || (infoUser && infoUser.userType === 6)) &&
                            <TreeItem itemId="generator" onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    event: 'button_click',
                                    button_id: 'download-generator',
                                });
                                window.open(`${process.env.REACT_APP_BACKEND_URL}/api/download-demo/GeneratorModule`)
                                setAnchorEl(null)
                            }}
                                label={
                                    <p style={{ marginTop: "0.4rem", marginBottom: "0.4rem", fontSize: "14px" }}>{t("board.generator")}</p>
                                } />
                        } */}
                    </TreeItem>
                    { ((infoUser && infoUser.developer) || (infoUser && infoUser.userType === 4)) &&
                        <TreeItem itemId="developer" label={
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: "1.5rem", fontSize: "14px"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" style={{margin: "0.5rem"}} >
                            <path d="M344-296 160-480l184-184 56 58-126 126 126 126-56 58Zm-144 16h80v40h400v-40h80v160q0 33-23.5 56.5T680-40H280q-33 0-56.5-23.5T200-120v-160Zm80-400h-80v-160q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v160h-80v-40H280v40Zm0 520v40h400v-40H280Zm0-640h400v-40H280v40Zm336 504-56-58 126-126-126-126 56-58 184 184-184 184ZM280-800v-40 40Zm0 640v40-40Z"/>
                        </svg>
                            {t("board.developer.developer")}
                        </div>
                    }>
                        <TreeItem itemId="developer-token" label={
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: "1.5rem", fontSize: "14px"}}
                                    onClick={() => {
                                        window.dataLayer = window.dataLayer || [];
                                        window.dataLayer.push({
                                        event: 'button_click',
                                        button_id:'developer-token',
                                        });
                                        copyToken()
                                    }}>
                                        <p style={{marginTop: "0.4rem", marginBottom: "0.4rem", fontSize: "14px"}}>{t("board.token")}</p>
                                    </div>
                                }
                             />
                        <TreeItem itemId="developer-api" label={
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: "1.5rem", fontSize: "14px"}}
                                    onClick={()=>{
                                        window.dataLayer = window.dataLayer || [];
                                        window.dataLayer.push({
                                        event: 'button_click',
                                        button_id:'python-code',
                                        });
                                        window.open( `${process.env.REACT_APP_BACKEND_URL}/api/download-demo/PythonCode`)
                                        setAnchorEl(null)
                                    }}>
                                            {t("board.developer.pythonCode")}
                                        </div>

                                }
                             />
                        </TreeItem>
                    }
                        <TreeItem itemId="configuracion" label={
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: "1.5rem", fontSize: "14px"}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" style={{margin: "0.5rem"}}>
                                        <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"/>
                                    </svg>
                                    {t('board.configuracion')}
                                </div>
                            }>
                                <TreeItem itemId="notificaciones" label={
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', fontSize: "14px"}}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20" fill="#5f6368" style={{marginRight: "0.5rem"}}>
                                        <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
                                    </svg>
                                    {t('board.notificaciones')}
                                    </div>
                                    <Switch
                                    {...label}
                                    checked={notificaciones}
                                    onChange={(e) => setNotificaciones(e.target.checked)}
                                    />
                                </div>
                                }/>
                                <TreeItem itemId="modo-oscuro" label={
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', fontSize: "14px"}}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20" fill="#5f6368" style={{marginRight: "0.5rem"}}>
                                        <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
                                    </svg>
                                    {t('board.modo-oscuro')}
                                    </div>
                                    <MaterialUISwitch
                                        checked={modoOscuro}
                                        onChange={(e) => {
                                            setModoOscuro(e.target.checked);
                                            if (e.target.checked) {
                                            document.body.classList.add('dark-mode');
                                            } else {
                                            document.body.classList.remove('dark-mode');
                                            }
                                        }}
                                        />
                                </div>
                                }/>
                            </TreeItem>
                </SimpleTreeView>

                <MenuItem>

                    <a style={{ fontSize: "14px" }} onClick={() => {
                        setIsCookieIcon(true);
                        localStorage.removeItem("saxToken");
                        localStorage.setItem('login', 'false');
                        window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/logout`
                    }}>
                        {//; return href={``}
                        }
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        {t('board.logOut')}
                    </a>

                </MenuItem>

            </Menu>
            <Snackbar
                open={openAlert}
                autoHideDuration={6000}
                onClose={handleCloseAlert}
                anchorOrigin={{vertical: 'top', horizontal: 'right'} }
            >
                <Alert onClose={handleCloseAlert} severity={"success"} sx={{ width: '100%' }}>
                    {t("board.copy")}
                </Alert>
            </Snackbar>
        </>
    );
}